// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_CalcularLucroInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /fechamentos/calcular_lucro/{id}
 *
 * Calculates profit/loss for a fechamento. No body required — id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Fechamentos_CalcularLucroInput {}

registerContract('Fechamentos_CalcularLucroInput', {})
